import { Injectable } from '@angular/core';
import { SxHttpService } from './sxHttp.service';
import { Observable } from 'rxjs/Observable';

export interface AtributoMetadata {
  columnaEnlaceDB: string;
  esColumna: boolean;
  esFiltro: boolean;
  esOrdenable: boolean;
  esVisible: boolean;
  extraInfo: string;
  position: number;
  tablaEnlaceDB: string;
  tipoFiltro: string;
}

export interface FormularioAtributo {
  idFormulario: string;
  codAtributo: string;
  descripcion: string;
  tipoDato: string;
  valorDefault: string;
  extraInfo: string;
  opcional: boolean;
  parsedMetadata: AtributoMetadata;
  formList: Formulario;
  hidden:boolean;
  commandCategory:string;
  commandSubCategory:string;
}

export interface Formulario {
  idFormulario: number;
  descripcion: string;
  codServicio: string;
  codComando: string;
  atributos: FormularioAtributo[];
}

export interface FormAttributeByType {
  serviceCode: string;
  formId: number;
  attributeCode: string;
  description: string;
}

@Injectable()
export class FormulariosService {
  private url = 'api/configuracionFormulario';

  constructor(private sxHttp: SxHttpService) { }

  getFormulario(idFormulario: string): Observable<Formulario> {
    const url = `${this.url}/${idFormulario}`;

    return this.sxHttp.get(url)
      .map(response => response.json().data as Formulario);
  }

  getAtributos(idFormulario: string): Promise<FormularioAtributo[]> {
    const url = `${this.url}/${idFormulario}/atributos`;

    return this.sxHttp.get(url)
      .toPromise()
      .then(response => response.json().data as FormularioAtributo[]);
  }

  crearAtributo(atributo: FormularioAtributo): Promise<FormularioAtributo> {
    const url = `${this.url}/${atributo.idFormulario}/atributos`;
    
    return this.sxHttp.post(url, atributo)
      .toPromise()
      .then(response => response.json().data as FormularioAtributo);
  }

  editarAtributo(atributo: FormularioAtributo): Promise<FormularioAtributo> {
    const url = `${this.url}/${atributo.idFormulario}/atributos/${atributo.codAtributo}`;

    return this.sxHttp.put(url, atributo)
      .toPromise()
      .then(response => response.json().data as FormularioAtributo);
  }

  eliminarAtributo(idFormulario: string, idAtributo: string): Promise<any> {
    const url = `${this.url}/${idFormulario}/atributos/${idAtributo}`;
    return this.sxHttp.delete(url)
      .toPromise()
      .then(response => response.json().data as any);
  }

  exportAttributes(idFormulario: string): Observable<string> {
    const url = `${this.url}/${idFormulario}/atributos/Export`;
    return this.sxHttp.get(url)
      .map(response =>
        response.json().data as string);
  }

  getProductAttributesByService(system: string, business: string, product: string): Promise<FormAttributeByType[]> {
    const actionUrl =
      `api/productDesigns/attributeByServiceTypeForProduct/${system}/${business}/${product}`;

    return this.sxHttp
      .get(actionUrl)
      .map(response => response.json().data as FormAttributeByType[])
      .toPromise();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/formularios.service.ts